// Mock data para o módulo Nogle Tech.
// Inspirado nas abas MARCA, VENDAS, SOLUÇÕES DE VENDA DAS MARCAS e PRODUTOS FINALIZADOS.

export const PRODUTOS = [
    'Solução de Vendas',
    'App Mobile',
    'Site Nogle Tech',
    'Notify',
    'ERP',
    'Split Fiscal',
    'Recarga Fácil',
];

export const SITUACOES = [
    'COLETANDO INFORMAÇÕES',
    'ESPERANDO A MARCA RESPONDER',
    'PRONTO PARA COMEÇAR',
    'SENDO PRODUZIDO',
    'EM TESTE',
    'CONCLUIDO',
    'ESTA PARADO',
    'NÃO TEM',
    'SEM DADOS',
];

export const STATUS_MARCA = ['Em Andamento', 'Concluida', 'Parada', 'SEM DADOS'];
export const PRIORIDADES = ['BAIXA', 'MÉDIA', 'ALTA', 'URGENTE'];
export const INFO_MARCA = [
    'INFORMAÇÕES COMPLETAS',
    'INFORMAÇÕES INCOMPLETAS',
    'COLETANDO MATERIAIS',
    'SEM DADOS',
];
export const FLUXO_ENTREGA = ['AGUARDANDO', 'DISPONIVEL', 'APRESENTADO'];

export const marcasMock = [
    {
        id: 1,
        nome: 'Max Mobile',
        status: 'Concluida',
        situacao: 'CONCLUIDO',
        prioridade: 'ALTA',
        info: 'INFORMAÇÕES COMPLETAS',
        solucoes: ['Solução de Vendas'],
        situacoesProduto: {
            'Solução de Vendas': 'CONCLUIDO',
            'App Mobile': 'NÃO TEM',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'NÃO TEM',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: { 'Solução de Vendas': 'https://compreaqui.maxmobiletech.com.br/' },
        fluxo: 'DISPONIVEL',
        dadosCadastrais: {
            '0800': '0800-700-2300',
            whatsapp: '0800 700 2300',
            corPrimaria: '#373435',
            corSecundaria: '#ED3237',
            dominio: 'maxmobiletech.com.br',
            plataforma: 'registro.br',
            login: 'MAMPR155',
            senha: 'Max@mobile@26',
            endereco: 'R. Carlos Trein Filho, 1055 - Centro, Santa Cruz do Sul - RS, 96810-166',
        },
    },
    {
        id: 2,
        nome: 'Ora Connect',
        status: 'Em Andamento',
        situacao: 'ESPERANDO A MARCA RESPONDER',
        prioridade: 'MÉDIA',
        info: 'INFORMAÇÕES INCOMPLETAS',
        solucoes: ['Solução de Vendas', 'App Mobile'],
        situacoesProduto: {
            'Solução de Vendas': 'ESPERANDO A MARCA RESPONDER',
            'App Mobile': 'ESPERANDO A MARCA RESPONDER',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'NÃO TEM',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: {},
        fluxo: 'AGUARDANDO',
        dadosCadastrais: { dominio: 'oraconnect.com.br' },
    },
    {
        id: 3,
        nome: 'Vox',
        status: 'Em Andamento',
        situacao: 'EM TESTE',
        prioridade: 'ALTA',
        info: 'INFORMAÇÕES COMPLETAS',
        solucoes: ['Solução de Vendas', 'App Mobile', 'Notify'],
        situacoesProduto: {
            'Solução de Vendas': 'CONCLUIDO',
            'App Mobile': 'EM TESTE',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'CONCLUIDO',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: {
            'Solução de Vendas': 'https://vox.vendas.nogle',
            'Notify': 'https://notify.vox',
        },
        fluxo: 'DISPONIVEL',
        dadosCadastrais: { dominio: 'vox.com.br' },
    },
    {
        id: 4,
        nome: 'Protege Mais',
        status: 'Em Andamento',
        situacao: 'ESPERANDO A MARCA RESPONDER',
        prioridade: 'MÉDIA',
        info: 'INFORMAÇÕES INCOMPLETAS',
        solucoes: ['Solução de Vendas', 'App Mobile'],
        situacoesProduto: {
            'Solução de Vendas': 'ESPERANDO A MARCA RESPONDER',
            'App Mobile': 'CONCLUIDO',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'NÃO TEM',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: { 'App Mobile': 'https://app.protegemais' },
        fluxo: 'AGUARDANDO',
        dadosCadastrais: {},
    },
    {
        id: 5,
        nome: 'Netecel',
        status: 'Em Andamento',
        situacao: 'COLETANDO MATERIAIS',
        prioridade: 'BAIXA',
        info: 'COLETANDO MATERIAIS',
        solucoes: ['Solução de Vendas', 'App Mobile'],
        situacoesProduto: {
            'Solução de Vendas': 'CONCLUIDO',
            'App Mobile': 'COLETANDO INFORMAÇÕES',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'NÃO TEM',
            'ERP': 'CONCLUIDO',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: {
            'Solução de Vendas': 'https://netecel.vendas',
            'ERP': 'https://erp.netecel',
        },
        fluxo: 'AGUARDANDO',
        dadosCadastrais: {},
    },
    {
        id: 6,
        nome: 'Servmóvel',
        status: 'Parada',
        situacao: 'ESTA PARADO',
        prioridade: 'URGENTE',
        info: 'INFORMAÇÕES INCOMPLETAS',
        solucoes: ['Solução de Vendas'],
        situacoesProduto: {
            'Solução de Vendas': 'ESTA PARADO',
            'App Mobile': 'NÃO TEM',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'NÃO TEM',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: {},
        fluxo: 'AGUARDANDO',
        dadosCadastrais: {},
    },
    {
        id: 7,
        nome: 'USA Telecom',
        status: 'Parada',
        situacao: 'ESTA PARADO',
        prioridade: 'URGENTE',
        info: 'INFORMAÇÕES INCOMPLETAS',
        solucoes: ['Solução de Vendas', 'App Mobile', 'Site Nogle Tech'],
        situacoesProduto: {
            'Solução de Vendas': 'ESTA PARADO',
            'App Mobile': 'ESTA PARADO',
            'Site Nogle Tech': 'CONCLUIDO',
            'Notify': 'NÃO TEM',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: { 'Site Nogle Tech': 'https://usatelecom.nogle' },
        fluxo: 'APRESENTADO',
        dadosCadastrais: {},
    },
    {
        id: 8,
        nome: 'Mottor',
        status: 'Parada',
        situacao: 'ESTA PARADO',
        prioridade: 'ALTA',
        info: 'INFORMAÇÕES INCOMPLETAS',
        solucoes: ['Solução de Vendas'],
        situacoesProduto: {
            'Solução de Vendas': 'ESTA PARADO',
            'App Mobile': 'NÃO TEM',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'NÃO TEM',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: {},
        fluxo: 'AGUARDANDO',
        dadosCadastrais: {},
    },
    {
        id: 9,
        nome: 'GkG Net Mobile',
        status: 'Em Andamento',
        situacao: 'EM TESTE',
        prioridade: 'MÉDIA',
        info: 'INFORMAÇÕES COMPLETAS',
        solucoes: ['App Mobile'],
        situacoesProduto: {
            'Solução de Vendas': 'NÃO TEM',
            'App Mobile': 'EM TESTE',
            'Site Nogle Tech': 'NÃO TEM',
            'Notify': 'NÃO TEM',
            'ERP': 'NÃO TEM',
            'Split Fiscal': 'NÃO TEM',
            'Recarga Fácil': 'NÃO TEM',
        },
        entregas: {},
        fluxo: 'AGUARDANDO',
        dadosCadastrais: {},
    },
];

export const vendasMock = [
    { id: 1, data: '2026-04-10', marca: 'Fellype Telecell', solucao: 'App Mobile', prazoDias: 30, prioridade: 'ALTA' },
    { id: 2, data: '2026-04-10', marca: 'Cell Phone Ltda', solucao: 'Solução de Vendas', prazoDias: 15, prioridade: 'URGENTE' },
    { id: 3, data: '2026-04-10', marca: 'Cases Telecom', solucao: 'Site Nogle Tech', prazoDias: 45, prioridade: 'MÉDIA' },
    { id: 4, data: '2026-04-10', marca: 'Versago', solucao: 'Notify Premium', prazoDias: 30, prioridade: 'BAIXA' },
    { id: 5, data: '2026-04-10', marca: 'Smart Workshop Augusto', solucao: 'App Mobile', prazoDias: 30, prioridade: 'ALTA' },
    { id: 6, data: '2026-03-28', marca: 'Ora Connect', solucao: 'Solução de Vendas', prazoDias: 30, prioridade: 'MÉDIA' },
    { id: 7, data: '2026-03-20', marca: 'Vox', solucao: 'Notify Standard', prazoDias: 20, prioridade: 'ALTA' },
];

export const solucoesCatalogoMock = [
    { marca: 'Max Mobile', status: 'Ativa', appMobile: false, linkVendas: true, notify: false, siteWeb: false, recarga: false },
    { marca: 'Ora Connect', status: 'Ativa', appMobile: true, linkVendas: true, notify: false, siteWeb: false, recarga: false },
    { marca: 'Vox', status: 'Ativa', appMobile: true, linkVendas: true, notify: true, siteWeb: false, recarga: false },
    { marca: 'Netecel', status: 'Ativa', appMobile: true, linkVendas: true, notify: false, siteWeb: false, recarga: false },
    { marca: 'Protege Mais', status: 'Nova', appMobile: true, linkVendas: true, notify: false, siteWeb: false, recarga: false },
    { marca: 'Servmóvel', status: 'inadiplente', appMobile: false, linkVendas: true, notify: false, siteWeb: false, recarga: false },
    { marca: 'USA Telecom', status: 'Parada', appMobile: true, linkVendas: true, notify: false, siteWeb: true, recarga: false },
    { marca: 'GkG Net Mobile', status: 'Ativa', appMobile: true, linkVendas: false, notify: false, siteWeb: false, recarga: false },
];
